module.exports = __webpack_public_path__ + "static/media/JNJSurvey.bb59876d.png";